import type { ImageProps as ImagePropsBase } from '@wix/design-system';
import { Image as ImageBase } from '@wix/design-system';
import React from 'react';

import { getImageSrc } from './../../wix-rich-content-common/lib/imageUtils';

type ImageProps = ImagePropsBase & {
  src: string;
  height: number;
  width: number;
  requiredWidth: number;
  requiredHeight: number;
};

export const Image: React.FC<ImageProps> = ({
  src,
  height,
  width,
  requiredHeight,
  requiredWidth,
  ...props
}) => {
  return (
    <ImageBase
      fit="contain"
      style={{ minHeight: requiredHeight, height: requiredHeight }}
      src={getImageSrc(
        {
          file_name: src,
          id: src,
          width,
          height,
        },
        undefined,
        {
          requiredWidth,
          requiredHeight,
          requiredQuality: 80,
        }
      )}
      borderRadius={0}
      {...props}
    />
  );
};
